import { usePermission } from './usePermission';
import Forbidden from '../pages/Forbidden';

// Assumes it's nested inside <RequireAuth> — only checks the permission itself, so a
// denied user still sees the surrounding AppLayout (sidebar/topbar) around the 403.
export default function RequirePermission({ perm, children }) {
  const { can } = usePermission();

  if (perm && !can(perm)) {
    return <Forbidden permission={perm} />;
  }

  return children;
}
